module.exports = require('./helpers/bundle-url').getBundleURL('5Yk8B') + "logo.c51670a8.svg";